import React, { useState } from 'react';
import './FormShow.css';

function FormShow() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    website: '',
    services: '',
    business: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <div className='container_1'>
      <div className='form-container'>
        <div className='header'>
          <h1 className='title'>
            Get in <span className='italic'>touch</span>.
          </h1>
          <p className='subtitle'>
            Ready to scale your brand to new heights? Book a call and let's
            discuss how we can bring your vision to life.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className='grid'>
            <div>
              <label className='label'>First Name</label>
              <input
                className='input'
                type='text'
                name='firstName'
                value={formData.firstName}
                onChange={handleChange}
                placeholder='Peter'
              />
            </div>
            <div>
              <label className='label'>Last Name</label>
              <input
                className='input'
                type='text'
                name='lastName'
                value={formData.lastName}
                onChange={handleChange}
                placeholder='Parker'
              />
            </div>
          </div>

          <label className='label'>Email</label>
          <input
            className='input'
            type='email'
            name='email'
            value={formData.email}
            onChange={handleChange}
            placeholder='peter@parker.com'
          />

          <label className='label'>Website</label>
          <input
            className='input'
            type='url'
            name='website'
            value={formData.website}
            onChange={handleChange}
            placeholder='www.parker.com'
          />

          <label className='label'>What services are you interested in?</label>
          <input
            className='input'
            type='text'
            name='services'
            value={formData.services}
            onChange={handleChange}
            placeholder='Google Ads'
          />

          <label className='label'>Tell me about your business?</label>
          <textarea
            className='input textarea'
            name='business'
            value={formData.business}
            onChange={handleChange}
            placeholder='What does your business sell or offer?'
          />

          <button type='submit' className='button'>
            Book a call
          </button>
        </form>
      </div>
    </div>
  );
}

export default FormShow;
